import { SeasonalMenu } from './SeasonalMenu';

export default SeasonalMenu;
